import { TextField, TextFieldProps, useTheme } from '@mui/material';
import { useDarkMode } from '../../hooks/useDarkMode';

export const StyledTextField = (props: TextFieldProps) => {
    const theme = useTheme();
    const { customColorPalette: palette } = theme;
    const isDarkMode = useDarkMode();

    return (
        <TextField
            {...props}
            sx={{
                backgroundColor: 'transparent',
                '& .MuiOutlinedInput-root': {
                    borderRadius: '4px',
                    backgroundColor: isDarkMode ? palette.gray[800] : '#fff',
                    color: isDarkMode ? palette.gray[100] : palette.gray[900],
                    '& fieldset': {
                        borderColor: isDarkMode ? palette.gray[700] : palette.gray[300],
                    },
                    '&:hover fieldset': {
                        borderColor: isDarkMode ? palette.gray[600] : '#ccc',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: palette.blue[500],
                    },
                },
                '& .MuiInputBase-input::placeholder': {
                    color: isDarkMode ? palette.gray[500] : palette.gray[400],
                    opacity: 1,
                },
                ...((props.sx as object) || {}),
            }}
        />
    );
};
